import $ from 'jquery';
import {Swiper, Autoplay, EffectFade} from 'swiper/js/swiper.esm.js';

Swiper.use([Autoplay, EffectFade])

$('.background-slider').each(function () {
    const $self = $(this);
    const swiper = new Swiper($self[0], {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        }
    });
});

